<div class="content content--page">
  <div class="content__inner">
    <div class="content__main content__main--page">
      <div class="card">
        <h1 class="card__title">Industry News</h1>
        <div class="card__content">
          <div class="notif notif--news">
            @for (newsItem of newsItems; track newsItem.id) {
            <div class="notif-item" [ngClass]="{ 'notif-item--new': newsItem.isNew }">
              <div class="notif-item__date">{{ newsItem.dateCreated | date:'MMM dd, yyyy' }}</div>
              <h3 class="notif-item__title">{{ newsItem.title }}</h3>
              <p class="notif-item__text">
                {{ newsItem.content }}
                @if (newsItem.link) {
                <a href="{{ newsItem.link }}" target="_blank">Read More</a>
                }
              </p>
            </div>
            }
          </div>
        </div>
        @if (loading) {
        <div class="loading-update">
          <div class="loading-update__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
